import React, { useEffect, useState } from "react";
import DataTable from "../../../../components/common/DataTable/DataTable";
import HeaderTitle from "../../../../components/common/HeaderTitle/HeaderTitle";
import { useSelector } from "react-redux";
import { useMerchantInvoiceDashboardOffline } from "../../../../offline";
import { Box, IconButton, TablePagination } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

function PaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
    onPageChange(event, lastPage);
  };

  const isBackDisabled = page === 0;
  const isNextDisabled = page >= Math.ceil(count / rowsPerPage) - 1;

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={isBackDisabled}
        aria-label="first page"
        size="medium"
        sx={{ p: 1.25 }}
      >
        {theme.direction === "rtl" ? (
          <LastPageIcon sx={{ fontSize: 24 }} />
        ) : (
          <FirstPageIcon sx={{ fontSize: 24 }} />
        )}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={isBackDisabled}
        aria-label="previous page"
        size="medium"
        sx={{ p: 1.25 }}
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight sx={{ fontSize: 24 }} />
        ) : (
          <KeyboardArrowLeft sx={{ fontSize: 24 }} />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={isNextDisabled}
        aria-label="next page"
        size="medium"
        sx={{ p: 1.25 }}
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft sx={{ fontSize: 24 }} />
        ) : (
          <KeyboardArrowRight sx={{ fontSize: 24 }} />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={isNextDisabled}
        aria-label="last page"
        size="medium"
        sx={{ p: 1.25 }}
      >
        {theme.direction === "rtl" ? (
          <FirstPageIcon sx={{ fontSize: 24 }} />
        ) : (
          <LastPageIcon sx={{ fontSize: 24 }} />
        )}
      </IconButton>
    </Box>
  );
}

const VendorInvoiceTable = () => {
  const [invoiceData, setInvoiceData] = useState([]);

  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const Data = useSelector((state) => state.loginData.value);
  const auth_token = Data?.auth_token;
  const user_token = Data?.user?.token || Data?.user_token;
  const org_id = Data?.org_id || Data?.user?.org_id || Data?.organization_id;
  const { data: dashboardSummary } = useMerchantInvoiceDashboardOffline(
    auth_token,
    user_token,
    org_id
  );

  const paginatedData = invoiceData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  useEffect(() => {
    // OLD API - deprecated after dashboard summary merge
    // axios.post(API_ENDPOINT.monthly_invoice_summary, { org_token: user_token })
    //   .then((res) => setInvoiceData(res.data.data || []));

    const monthlySummary = dashboardSummary?.monthly_invoice_summary || {};
    const apiData = Array.isArray(monthlySummary?.data) ? monthlySummary.data : [];

    const formattedData = apiData.map((row) => {
      const formattedRow = { ...row };

      Object.keys(formattedRow).forEach((key) => {
        if (
          key.toLowerCase().includes("jan") ||
          key.toLowerCase().includes("feb") ||
          key.toLowerCase().includes("mar") ||
          key.toLowerCase().includes("apr") ||
          key.toLowerCase().includes("may") ||
          key.toLowerCase().includes("jun") ||
          key.toLowerCase().includes("jul") ||
          key.toLowerCase().includes("aug") ||
          key.toLowerCase().includes("sep") ||
          key.toLowerCase().includes("oct") ||
          key.toLowerCase().includes("nov") ||
          key.toLowerCase().includes("dec") ||
          key.toLowerCase().includes("total")
        ) {
          const value = formattedRow[key];
          if (!isNaN(value) && value !== null) {
            formattedRow[key] = Number(value).toLocaleString("en-IN");
          }
        }
      });

      return formattedRow;
    });

    setInvoiceData(formattedData);
  }, [dashboardSummary]);

  const currentYear =
    dashboardSummary?.monthly_invoice_summary?.year || new Date().getFullYear();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const tableHeaders = [
    "Merchant Name",
    ...months.map((month) => `${month} (${currentYear})`),
    `Total YTD (${currentYear})`,
  ];

  const Tableheadings = tableHeaders.map((header) => ({
    label: header,
    field: header.replace(/\s+/g, "_").toLowerCase().replace(/[()]/g, ""),
  }));

  return (
    <div style={{ margin: "auto", padding: "1rem" }}>
      <div style={{ overflowX: "auto", marginBottom: "2rem" }}>
        <div>
          <HeaderTitle titleText={"Payment Processed"} />
        </div>

        <DataTable
          headings={Tableheadings}
          tableData={paginatedData}
          actions={false}
          tableSize={paginatedData?.length === 0 ? "100%" : "100%"}
          viewBtn={false}
          sorting={true}
          editBtn={false}
          deleteBtn={false}
        />

        {invoiceData.length > rowsPerPage && (
          <TablePagination
            component="div"
            count={invoiceData.length}
            page={page}
            onPageChange={(event, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={() => {}}
            rowsPerPageOptions={[rowsPerPage]}
            showFirstButton
            showLastButton
            ActionsComponent={PaginationActions}
            sx={{
              "& .MuiTablePagination-toolbar": { fontSize: "14px" },
              "& .MuiTablePagination-selectLabel": { fontSize: "14px" },
              "& .MuiTablePagination-displayedRows": { fontSize: "14px" },
              "& .MuiTablePagination-select": { fontSize: "14px" },
            }}
          />
        )}
      </div>
    </div>
  );
};

export default VendorInvoiceTable;
